// universes-layout.component.ts
import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { PlayerProfileModel } from 'src/app/core/models/player/player-profile-result';
import { MenuInfo } from 'src/app/core/models/user/menu-info.model';
import { ModuleSectionsService } from 'src/app/core/services/module-sections/module-sections.service';
import {
  getAllDraftItems,
  getContributorItems,
  getDraftItems,
  getInventoryItems,
} from 'src/app/core/store/catalog.actions';

@Component({
  selector: 'app-creator-layout',
  templateUrl: './creator-layout.component.html',
  styleUrls: ['./creator-layout.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class CreatorLayoutComponent implements OnInit {
  moduleSections = inject(ModuleSectionsService);
  private store = inject(Store);

  menuData!: MenuInfo;

  PlayerProfile!: PlayerProfileModel;

  ngOnInit() {
    /* Run the queries */
    this.store.dispatch(getAllDraftItems());
    this.store.dispatch(getContributorItems());
    this.store.dispatch(getInventoryItems());
  }
}
